<div class="profile-selection-container">
  <h2 class="modal-title">Selecciona tu perfil</h2>

  <!-- Subtítulo -->
  <p class="modal-subtitle">Selecciona el perfil con el que deseas continuar</p>

  <!-- Barra de búsqueda -->
  <div class="search-container">
    <div class="search-input-wrapper">
      <input type="text"
            class="search-input"
            [value]="searchTerm"
            (input)="onSearchInput($event)"
            placeholder="Escribe el nombre del perfil..."
            autofocus>
      <i class="material-icons search-icon">search</i>
    </div>
  </div>

  <!-- Mensaje inicial -->
  <div *ngIf="showInitialMessage && !loading" class="initial-message p-3">
    <i class="material-icons search-icon-large">search</i>
    <p class="message-title">Busca tu perfil</p>
    <p class="message-subtitle">Escribe al menos 3 caracteres para comenzar la búsqueda</p>
  </div>

  <!-- Mensaje de búsqueda corta -->
  <div *ngIf="!showInitialMessage && !loading && searchTerm.length > 0 && searchTerm.length < minSearchLength" class="short-search-message p-3">
    <p>Escribe al menos {{ minSearchLength }} caracteres para buscar</p>
  </div>

  <!-- Loader -->
  <div *ngIf="loading" class="text-center p-3">
    <div class="spinner">
      <span>Buscando perfiles...</span>
    </div>
  </div>

  <!-- Error message -->
  <div *ngIf="!loading && errorMessage" class="error-message p-3">
    <p>{{ errorMessage }}</p>
    <button mat-button color="primary" (click)="loadProfiles()">
      Reintentar
    </button>
  </div>

  <!-- Profile list -->
  <div *ngIf="!loading && !errorMessage && profileList && profileList.length > 0" class="profile-list">
    <div class="profiles-container">
      <div class="profile-option"
          *ngFor="let profile of filteredProfileList"
          [class.selected]="isProfileSelected(profile)"
          [class.current]="isCurrentProfile(profile)"
          (click)="onSelectProfile(profile)">
        <div class="profile-check-container">
          <div class="check-circle" [class.checked]="isProfileSelected(profile)">
            <i *ngIf="isProfileSelected(profile)" class="material-icons">check</i>
          </div>
        </div>
        <div class="profile-info">
          <div class="profile-name">{{ profile.Name }}</div>
          <div class="profile-ssn" *ngIf="profile.SocialSecurityNumber">{{ maskSSN(profile.SocialSecurityNumber) }}</div>
        </div>
      </div>

      <div class="profile-option add-profile" (click)="addNewProfile()">
        <div class="profile-icon-container">
          <img src="assets/images/salud/icons/add_circle.svg" alt="add-profile-icon" class="profile-icon"/>
        </div>
        <div class="profile-info">
          <div class="profile-name">Crear nuevo perfil</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state - No profiles at all (dentro del área de scroll) -->
  <div *ngIf="!loading && !errorMessage && profileList.length === 0 && searchTerm.length < minSearchLength" class="profile-list">
    <div class="profiles-container">
      <div class="empty-state-modal">
        <i class="material-icons empty-icon">person_add</i>
        <h3 class="empty-title">No tienes perfiles creados</h3>
        <p class="empty-description">
          Crea tu primer perfil para comenzar a utilizar el sistema
        </p>
        <button
          mat-raised-button
          color="primary"
          class="create-profile-button"
          (click)="addNewProfile()"
        >
          <mat-icon>add</mat-icon>
          Crear mi primer perfil
        </button>
      </div>
    </div>
  </div>

  <!-- No results message (dentro del área de scroll) -->
  <div *ngIf="!loading && !errorMessage && !showInitialMessage && searchTerm.length >= minSearchLength && profileList.length === 0" class="profile-list">
    <div class="profiles-container">
      <div class="no-results-message">
        <i class="material-icons">sentiment_dissatisfied</i>
        <p>No se encontraron perfiles con "{{ searchTerm }}"</p>
        <p class="subtitle">Intenta con otro nombre</p>
      </div>
    </div>
  </div>

  <!-- Action buttons -->
  <div class="button-container">
    <!-- Perfil seleccionado (siempre visible si existe) -->
    <div *ngIf="selectedProfile" class="selected-profile-display-inline">
      <div class="selected-profile-header">
        <span>Perfil seleccionado:</span>
      </div>
      <div class="selected-profile-item">
        <div class="profile-check-container">
          <div class="check-circle checked">
            <i class="material-icons">check</i>
          </div>
        </div>
            <div class="profile-info">
              <div class="profile-name">{{ getSelectedProfileObject()?.Name || 'Cargando...' }}</div>
              <div class="profile-ssn" *ngIf="getSelectedProfileObject()?.SocialSecurityNumber">{{ maskSSN(getSelectedProfileObject().SocialSecurityNumber) }}</div>
            </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="action-buttons">
      <button (click)="cancel()" class="cancel-button">Cancelar</button>
      <button class="select-profile-button" [disabled]="!selectedProfile" (click)="selectProfile()">
        Seleccionar
      </button>
    </div>
  </div>
</div>
